var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","return-object":"","hide-details":"","item-text":"gestion","items":_vm.items,"label":"Gestion","dense":""},model:{value:(_vm.gestion),callback:function ($$v) {_vm.gestion=$$v},expression:"gestion"}})
}
var staticRenderFns = []

export { render, staticRenderFns }